import { FC } from 'react';

import { Box } from '@mui/material';
import { professionNavigation } from 'const';
import { useAppSelector } from 'hooks';

import GenericApplicationCard from '../../components/GenericApplicationCard';
import GenericEntityList from '../../components/GenericEntityList';
import NoDataPlug from '../../components/NoDataPlug';
import { proforientationApplicationSelectors } from '../../model/selectors';
import { filterApplicationEntites } from '../../utils/statusUtils';
import { WidgetType } from '../widgets';

interface IApplicationExcursionsWidgetProps {
  applicationStatusCode: number | null;
}

const ApplicationExcursionsWidget: FC<IApplicationExcursionsWidgetProps> = ({ applicationStatusCode }) => {
  const excursions = useAppSelector(proforientationApplicationSelectors.excursions);

  const filterdExcursions = excursions.filter(filterApplicationEntites(applicationStatusCode));

  if (filterdExcursions.length === 0) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', paddingTop: '16px' }}>
        <NoDataPlug title="Ничего не найдено" />
      </Box>
    );
  }

  return (
    <GenericEntityList
      containerId={`${professionNavigation.applications.id}/excursions`}
      entities={filterdExcursions}
      initialCardCount={3}
      renderEntityCard={(entity) => {
        return (
          <GenericApplicationCard
            key={entity.eventId}
            date={entity.formattedDate}
            industry={entity.industry}
            name={entity.name}
            place={entity.place}
            statusApplicationCode={entity.statusApplication}
            typeApplication={WidgetType.EXCURSIONS}
          />
        );
      }}
    />
  );
};

export default ApplicationExcursionsWidget;
